import { useLocation } from "react-router-dom";
import { useQueryString } from "@/hooks";
import {
  isPortalAuthPath,
  isPortalHomePath,
  PORTAL_QUERY_PARAMS,
  portalAuthPaths,
  SIGNUP_SCREEN,
} from "./portal_paths";

interface SignedOutScreenParams {
  screen?: string;
}

// Which form a signed-out visitor should see. Signup is reached either by its own
// path or by a parameter carried over from a checkout hand-off.
//
// The parameter is honoured only at a partner's own address or on an auth path.
// A page nested beneath the portal is a request for that page, not for signup, so
// a stray parameter on a deep link must not turn it into a signup form.
export function usePortalSignedOutScreen(): "login" | typeof SIGNUP_SCREEN {
  const { pathname } = useLocation();
  const query = useQueryString<SignedOutScreenParams>();

  if (pathname === portalAuthPaths.signup) {
    return SIGNUP_SCREEN;
  }

  const screenIsHonoured =
    isPortalHomePath(pathname) || isPortalAuthPath(pathname);
  const asksForSignup =
    query[PORTAL_QUERY_PARAMS.screen]?.toLowerCase() === SIGNUP_SCREEN;

  return screenIsHonoured && asksForSignup ? SIGNUP_SCREEN : "login";
}
